// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__montserrat_ca0951', '__montserrat_Fallback_ca0951'"},"className":"__className_ca0951","variable":"__variable_ca0951"};